import React from "react";

import {
  Grid,
  Button,
  Box
} from "@mui/material";
import "./Genre.css";
import ImportExportIcon from "@mui/icons-material/ImportExport";

import {
  // GenerPanelContainer,
  // Generpanel,
  // GenerPanelList,
  // GenerPanelAgeGroup,
  GenerPanelSort,
  GenerPanelListButton,
  GenerPanelAgeGroupButton,
} from "./GenrePanelStyling";

const GenrePanel = ({
  generList,
  ageGroupList,
  handleClick,
  handleSortChange,
  Genre,
  sort,
}) => {

  return (
    <>
      <Grid
        container
        spacing={2}
        direction="row"
        item
        alignItems="center"
        justifyContent="center"
      >
        <Grid item>
          <Grid container spacing={2} direction="column">
            <Grid item >
              {generList.map((ele) => (
                <Button
                  key={ele.id}
                  variant="contained"
                  style={GenerPanelListButton}
                  onClick={() => handleClick(ele.value)}
                  className={Genre.includes(ele.value) ? "btn genre-btn" : "genre-btn"}
                 
                >
                  {ele.name}
                </Button>
              ))}
            </Grid>
            <Grid item >
              {ageGroupList.map((ele) => (
                <Button
                  key={ele.id}
                  variant="contained"
                  style={GenerPanelAgeGroupButton}
                  onClick={() => handleClick(ele.value)}
                  className={Genre.includes(ele.value) ? "btn content-rating-btn" : "content-rating-btn"}
                >
                  {ele.name}
                </Button>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {/* <FormControl style={GenerPanelSort}>
            <InputLabel
            // startIcon={<ImportExportIcon />}
            >
              sort By: {sort}
            </InputLabel>
            <Select value="Release Date" onChange={(e) => handleSortChange(e)}>
              <MenuItem value="Release Date">Release Date</MenuItem>
              <MenuItem value="View Count">View Count</MenuItem>
            </Select>
          </FormControl> */}
          <Box>
            <ImportExportIcon />
            <select
              style={GenerPanelSort}
              name="sortby"
              id="sortby"
              onChange={(e) => handleSortChange(e)}
              className="sort-select"
            >
              <option id="release-date-option" value="releaseDate">Release Date</option>
              <option  id="view-count-option" value="viewCount">View Count</option>
            </select>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default GenrePanel;
